<template>
  <div>
    <div class="row align-items-center">
      <label class="col-3 form-label px-1 mb-0">試合番号:</label>
      <div class="col-3">
        <span style="color:red; font-weight: 800">{{ matchKey }}</span>
      </div>
      <label class="col-3 form-label px-1 text-end mb-0">実コート:</label>
      <div class="col-3">
        <input type="text" class="form-control form-control-sm text-center" v-model="actualCourt" maxlength="3" style="width: 60px;">
      </div>
    </div>
    <div class="row mb-0">
      <!-- PCビュー -->
      <table class="table table-bordered align-middle mb-1 px-1 d-none d-md-table">
        <tbody>
          <tr>
            <td class="text-center" style="border-right: 0; width: 15%;">
              <TeamLabelComponent :teamId="match.left_team_id_1"/><br>
              <TeamLabelComponent :teamId="match.left_team_id_2" v-if="match.left_team_id_2 != '' && match.left_team_id_1 != match.left_team_id_2"/>
            </td>
            <td class="text-center player-name-cell" style="border-left: 0;border-right: 0; width: 32%;">
              {{ match.left_player_name_1 }}<br>{{ match.left_player_name_2 }}
            </td>
            <td class="text-center vs-cell" style="border-left: 0;border-right: 0; width: 6%;">vs.</td>
            <td class="text-center player-name-cell" style="border-left: 0;border-right: 0; width: 32%;">
              {{ match.right_player_name_1 }}<br>{{ match.right_player_name_2 }}
            </td>
            <td style="border-left: 0; width: 15%;">
              <TeamLabelComponent :teamId="match.right_team_id_1"/><br>
              <TeamLabelComponent :teamId="match.right_team_id_2" v-if="match.right_team_id_2 != '' && match.right_team_id_1 != match.right_team_id_2"/>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- スマホビュー -->
      <div class="d-md-none">
        <div class="row">
          <div class="col-6 text-center">
            <TeamLabelComponent :teamId="match.left_team_id_1"/>
          </div>
          <div class="col-6 text-center">
            <TeamLabelComponent :teamId="match.right_team_id_1"/>
          </div>
        </div>
        <div class="row">
          <div class="col-6 text-center px-1">
            {{ match.left_player_name_1 }}
          </div>
          <div class="col-6 text-center px-1">
            {{ match.right_player_name_1 }}
          </div>
        </div>
        <div class="row mt-2" v-if="match.left_team_id_2 != '' && match.left_team_id_1 != match.left_team_id_2 || match.right_team_id_2 != '' && match.right_team_id_1 != match.right_team_id_2">
          <div class="col-6 text-center">
            <TeamLabelComponent :teamId="match.left_team_id_2" v-if="match.left_team_id_2 != '' && match.left_team_id_1 != match.left_team_id_2"/>
          </div>
          <div class="col-6 text-center">
            <TeamLabelComponent :teamId="match.right_team_id_2" v-if="match.right_team_id_2 != '' && match.right_team_id_1 != match.right_team_id_2"/>
          </div>
        </div>
        <div class="row" v-if="match.left_player_name_2 || match.right_player_name_2">
          <div class="col-6 text-center px-1">
            {{ match.left_player_name_2 }}
          </div>
          <div class="col-6 text-center px-1">
            {{ match.right_player_name_2 }}
          </div>
        </div>
      </div>

    <table class="table table-bordered align-middle my-1 py-1">
        <tbody>

        <tr class="text-center">
            <td style="background-color: lightgray; height:10px;" class="m-0 p-0"><span style="font-size: 12pt;">勝者</span></td>
            <td style="background-color: lightgray; height:10px;" class="m-0 p-0" colspan="3"><span style="font-size: 12pt;">スコア</span></td>
            <td style="background-color: lightgray; height:10px;" class="m-0 p-0"><span style="font-size: 12pt;">勝者</span></td>
        </tr>
        <tr class="text-center">
            <td style="background-color: #a3cfbb; height:10px;" class="m-0 p-0" colspan="5"><span style="font-size: 12pt;">ゲーム</span></td>
        </tr>
        <tr style="border-color: silver;">
            <td class="text-center clickable-cell" style="border: 0; background-color: whitesmoke;">
              <label style="display: inline-block; width: 100%;">
                <input type="checkbox" id="game1_left_winner_flag" tabindex="5" :checked="match.game1_winner_entry_id === match.left_entry_id" @change="handleWinnerChange('game1_winner_entry_id', match.left_entry_id)">
              </label>
            </td>
            <td class="text-center" style="border: 0;">
              <div class="score-input-container">
                <input type="number" style='width: 43px;' tabindex="6" v-model="match.left_game1_score" @focus="activeScoreField = 'left_game1_score'" >
                <div v-if="activeScoreField === 'left_game1_score'" class="range-popup-left">
                  <div class="range-scale">
                      <span>0</span>
                      <span>10</span>
                      <span>21</span>
                  </div>
                  <input type="range" class="form-range" min="0" max="21" v-model="match.left_game1_score">
                  <br>
                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-top: 20px;">
                    <font-awesome-icon class="score-button" :icon="['fas', 'circle-minus']" style="color: #0d6efd; font-size: 1.4rem;" @click="decrementScore('left_game1_score')"/> 
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="hideRangeInput()">閉じる</button>
                    <font-awesome-icon class="score-button" :icon="['fas', 'circle-plus']" style="color: #0d6efd; font-size: 1.4rem;" @click="incrementScore('left_game1_score')"/>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center" style="border: 0; background-color: whitesmoke; width: 15%;"><span style="font-size: 12pt;">1st</span></td>
            <td class="text-center" style="border: 0;">
              <div class="score-input-container">
              <input type="number" style='width: 43px;' tabindex="7" v-model="match.right_game1_score" @focus="activeScoreField = 'right_game1_score'">
              <div v-if="activeScoreField === 'right_game1_score'" class="range-popup-right">
                <div class="range-scale">
                  <span>0</span>
                  <span>10</span>
                  <span>21</span>
                </div>
                <input type="range" class="form-range" min="0" max="21" v-model="match.right_game1_score">
                <br>
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-top: 20px;">
                  <font-awesome-icon class="score-button" :icon="['fas', 'circle-minus']" style="color: #0d6efd; font-size: 1.4rem;" @click="decrementScore('right_game1_score')"/> 
                  <button type="button" class="btn btn-outline-secondary btn-sm" @click="hideRangeInput()">閉じる</button>
                  <font-awesome-icon class="score-button" :icon="['fas', 'circle-plus']" style="color: #0d6efd; font-size: 1.4rem;" @click="incrementScore('right_game1_score')"/>
                </div>
              </div>
              </div>
            </td>
            <td class="text-center clickable-cell" style="border: 0; background-color: whitesmoke;">
              <label style="display: inline-block; width: 100%;">
              <input type="checkbox" id="game1_right_winner_flag" tabindex="8" :checked="match.game1_winner_entry_id === match.right_entry_id" @change="handleWinnerChange('game1_winner_entry_id', match.right_entry_id)">
              </label>
              <input type="hidden" v-model="match.game1_winner_entry_id">
            </td>
        </tr>
        <tr style="border-color: silver;">
            <td class="text-center clickable-cell" style="border: 0; background-color: whitesmoke;">
              <label style="display: inline-block; width: 100%;">
              <input type="checkbox" id="game2_left_winner_flag" tabindex="9" :checked="match.game2_winner_entry_id === match.left_entry_id" @change="handleWinnerChange('game2_winner_entry_id', match.left_entry_id)">
              </label>
            </td>
            <td class="text-center" style="border: 0;">
              <div class="score-input-container">
                <input type="number" style='width: 43px;' tabindex="10" v-model="match.left_game2_score" @focus="activeScoreField = 'left_game2_score'">
                <div v-if="activeScoreField === 'left_game2_score'" class="range-popup-left">
                <div class="range-scale">
                  <span>0</span>
                  <span>10</span>
                  <span>21</span>
                </div>
                <input type="range" class="form-range" min="0" max="21" v-model="match.left_game2_score">
                <br>
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-top: 20px;">
                  <font-awesome-icon class="score-button" :icon="['fas', 'circle-minus']" style="color: #0d6efd; font-size: 1.4rem;" @click="decrementScore('left_game2_score')"/> 
                  <button type="button" class="btn btn-outline-secondary btn-sm" @click="hideRangeInput()">閉じる</button>
                  <font-awesome-icon class="score-button" :icon="['fas', 'circle-plus']" style="color: #0d6efd; font-size: 1.4rem;" @click="incrementScore('left_game2_score')"/>
                </div>
              </div>
              </div>
            </td>
            <td class="text-center" style="border: 0; background-color: whitesmoke; width: 15%;"><span style="font-size: 12pt;">2nd</span></td>
            <td class="text-center" style="border: 0;">
              <div class="score-input-container">
                <input type="number" style='width: 43px;' tabindex="11" v-model="match.right_game2_score" @focus="activeScoreField = 'right_game2_score'">
                <div v-if="activeScoreField === 'right_game2_score'" class="range-popup-right" >
                  <div class="range-scale">
                    <span>0</span>
                    <span>10</span>
                    <span>21</span>
                  </div>
                  <input type="range" class="form-range" min="0" max="21" v-model="match.right_game2_score">
                  <br>
                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-top: 20px;">
                    <font-awesome-icon class="score-button" :icon="['fas', 'circle-minus']" style="color: #0d6efd; font-size: 1.4rem;" @click="decrementScore('right_game2_score')"/> 
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="hideRangeInput()">閉じる</button>
                    <font-awesome-icon class="score-button" :icon="['fas', 'circle-plus']" style="color: #0d6efd; font-size: 1.4rem;" @click="incrementScore('right_game2_score')"/>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center clickable-cell" style="border: 0; background-color: whitesmoke;">
              <label style="display: inline-block; width: 100%;">
              <input type="checkbox" id="game2_right_winner_flag" tabindex="12" :checked="match.game2_winner_entry_id === match.right_entry_id" @change="handleWinnerChange('game2_winner_entry_id', match.right_entry_id)">
              </label>
              <input type="hidden" v-model="match.game2_winner_entry_id">
            </td>
        </tr>
        <tr style="border-color: silver;">
            <td class="text-center clickable-cell" style="border: 0; background-color: whitesmoke;">
              <label style="display: inline-block; width: 100%;">
              <input type="checkbox" id="game3_left_winner_flag" tabindex="13" :checked="match.game3_winner_entry_id === match.left_entry_id" @change="handleWinnerChange('game3_winner_entry_id', match.left_entry_id)">
              </label>
            </td>
            <td class="text-center" style="border: 0;">
              <div class="score-input-container">
                <input type="number" style='width: 43px;' tabindex="14" v-model="match.left_game3_score" @focus="activeScoreField = 'left_game3_score'">
                <div v-if="activeScoreField === 'left_game3_score'" class="range-popup-left">
                  <div class="range-scale">
                    <span>0</span>
                    <span>10</span>
                    <span>21</span>
                  </div>
                  <input type="range" class="form-range" min="0" max="21" v-model="match.left_game3_score">
                  <br>
                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-top: 20px;">
                    <font-awesome-icon class="score-button" :icon="['fas', 'circle-minus']" style="color: #0d6efd; font-size: 1.4rem;" @click="decrementScore('left_game3_score')"/> 
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="hideRangeInput()">閉じる</button>
                    <font-awesome-icon class="score-button" :icon="['fas', 'circle-plus']" style="color: #0d6efd; font-size: 1.4rem;" @click="incrementScore('left_game3_score')"/>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center" style="border: 0; background-color: whitesmoke; width: 15%;"><span style="font-size: 12pt;">Final</span></td>
            <td class="text-center" style="border: 0;">
              <div class="score-input-container">
                <input type="number" style='width: 43px;' tabindex="15" v-model="match.right_game3_score" @focus="activeScoreField = 'right_game3_score'">
                <div v-if="activeScoreField === 'right_game3_score'" class="range-popup-right">
                  <div class="range-scale">
                    <span>0</span>
                    <span>10</span>
                    <span>21</span>
                  </div>
                  <input type="range" class="form-range" min="0" max="21" v-model="match.right_game3_score">
                  <br>
                  <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-top: 20px;">
                    <font-awesome-icon class="score-button" :icon="['fas', 'circle-minus']" style="color: #0d6efd; font-size: 1.4rem;" @click="decrementScore('right_game3_score')"/> 
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="hideRangeInput()">閉じる</button>
                    <font-awesome-icon class="score-button" :icon="['fas', 'circle-plus']" style="color: #0d6efd; font-size: 1.4rem;" @click="incrementScore('right_game3_score')"/>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center clickable-cell" style="border: 0; background-color: whitesmoke;">
              <label style="display: inline-block; width: 100%;">
              <input type="checkbox" id="game3_right_winner_flag" tabindex="16" :checked="match.game3_winner_entry_id === match.right_entry_id" @change="handleWinnerChange('game3_winner_entry_id', match.right_entry_id)">
              </label>
              <input type="hidden" v-model="match.game3_winner_entry_id">
            </td>
        </tr>
        <tr class="text-center">
            <td style="background-color: #a3cfbb; height:10px;" class="m-0 p-0" colspan="5"><span style="font-size: 12pt;">マッチ</span></td>
        </tr>
        <tr>
            <td class="text-center clickable-cell" style="border: 0; background-color: whitesmoke;">
              <label style="display: inline-block; width: 100%;">
                <input type="checkbox" id="match_left_winner_flag" tabindex="17" :checked="match.winner_entry_id === match.left_entry_id" @change="handleWinnerChange('winner_entry_id', match.left_entry_id)">
              </label>
            </td>
            <td class="text-center" style="border: 0;">
              <input type="number" style='width: 43px;' readonly v-model="match.left_game_win_count">
            </td>
            <td class="text-center" style="border: 0; background-color: whitesmoke; width: 15%;"><span style="font-size: 12pt;">ー</span></td>
            <td class="text-center" style="border: 0;">
              <input type="number" style='width: 43px;' readonly v-model="match.right_game_win_count">
            </td>
            <td class="text-center clickable-cell" style="border: 0; background-color: whitesmoke;">
              <label style="display: inline-block; width: 100%;">
              <input type="checkbox" id="match_right_winner_flag" tabindex="18" :checked="match.winner_entry_id === match.right_entry_id" @change="handleWinnerChange('winner_entry_id', match.right_entry_id)">
              </label>
              <input type="hidden" v-model="match.winner_entry_id">
            </td>
        </tr>
        </tbody>
    </table>

    <table class="table table-bordered align-middle mb-1 py-1">
        <tbody>
        <tr class="text-center">
            <td style="background-color: lightgray; height:10px; border: 0;" class="m-0 p-0" colspan="5"><span style="font-size: 12pt;">状況</span></td>
        </tr>
        <tr>
            <td class="text-center clickable-cell" style="border: 0;">
                <label style="display: inline-block; width: 100%;">
                    <input type="radio" name="match_status" id="status_waiting" value="waiting" tabindex="1" v-model="match.match_status"/><br/>
                    <span :class="{ 'fw-bold': match.match_status === 'waiting' }" :style="{ color: match.match_status === 'waiting' ? 'black' : 'slategray' }"> 待　機</span>
                </label>
            </td>
            <td class="text-center clickable-cell" style="background-color: cornsilk; border: 0;">
                <label style="display: inline-block; width: 100%;">
                    <input type="radio" name="match_status" id="status_called" value="called" tabindex="2" v-model="match.match_status"/><br/>
                    <span :class="{ 'fw-bold': match.match_status === 'called' }" :style="{ color: match.match_status === 'called' ? 'black' : 'slategray' }"> 招集中</span>
                </label>
            </td>
            <td class="text-center clickable-cell" style="background-color: peachpuff; border: 0;">
                <label style="display: inline-block; width: 100%;">
                    <input type="radio" name="match_status" id="status_called_finished" value="called_finished" tabindex="3" v-model="match.match_status"/><br/>
                    <span :class="{ 'fw-bold': match.match_status === 'called_finished' }" :style="{ color: match.match_status === 'called_finished' ? 'black' : 'slategray' }"> 招集済</span>
                </label>
            </td>
            <td class="text-center clickable-cell" style="background-color: aliceblue; border: 0;">
                <label style="display: inline-block; width: 100%;">
                    <input type="radio" name="match_status" id="status_playing" value="playing" tabindex="4" v-model="match.match_status"/><br/>
                    <span :class="{ 'fw-bold': match.match_status === 'playing' }" :style="{ color: match.match_status === 'playing' ? 'black' : 'slategray' }"> 試合中</span>
                </label>
            </td>
            <td class="text-center clickable-cell" style="border: 0;">
                <label style="display: inline-block; width: 100%;">
                    <input type="radio" name="match_status" id="status_finished" value="finished" tabindex="5" v-model="match.match_status"/><br/>
                    <span :class="{ 'fw-bold': match.match_status === 'finished' }" :style="{ color: match.match_status === 'finished' ? 'black' : 'slategray' }"> 終　了</span>
                </label>
            </td>
        </tr>
        <tr class="text-center">
            <td style="background-color: lightgray; height:10px; border: 0;" class="m-0 p-0" colspan="5"><span style="font-size: 12pt;">お知らせ</span></td>
        </tr>
        <tr class="text-center">
            <td colspan="5" style="border: 0;"><input type="text" v-model="match.note" style="width: 280px;" tabindex="19"></td>
        </tr>
        </tbody>
    </table>
    </div>
    <div class="modal-footer">
        <div>
            <span>
                <button type="button" class="btn btn-secondary" tabindex="20" data-bs-dismiss="modal">戻る</button>&nbsp;
                <button type="button" class="btn btn-outline-primary filter-btn filter-reset-btn"
                    @click="clearInputClicked" id="clear-button" tabindex="21">クリア</button>&nbsp;
                <button type="button" class="btn btn-primary" tabindex="22" @click="saveMatchScore" data-bs-dismiss="modal">保存する</button>
            </span>
        </div>
        <!-- <div>
            <span v-if="errorMessage" style="color: red"><br>{{ errorMessage }}</span>
        </div> -->
    </div>
  </div>
  <div class="text-center" v-if="isLoading">
    <div class="spinner-border spinner" role="status">
        <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { getAuth } from "firebase/auth"
import { ref as fbRef, update, getDatabase } from "firebase/database"
import TeamLabelComponent from './TeamLabelComponent.vue'

const auth = getAuth()
const user = auth.currentUser
const db = getDatabase()
const dbRef = fbRef(db)
const isLoading = ref()
const activeScoreField = ref(null)
const actualCourt = ref('')

const props = defineProps({
  match: {
    type: Object,
    required: true
  },
  matchKey: {
    type: String,
    required: true
  }
})

// ページ全体のクリックイベントを監視
onMounted(() => {
  document.addEventListener('mousedown', hideRangeInput)
  // actualCourtを初期化
  actualCourt.value = props.match.actual_court || ''
})

onUnmounted(() => { 
  document.removeEventListener('mousedown', hideRangeInput)
})

// winner_entry_idの変更を監視
watch(() => props.match.winner_entry_id, (newValue) => {
  if (newValue) {
    props.match.match_status = 'finished'
  }
})

// matchのactual_courtの変更を監視
watch(() => props.match.actual_court, (newValue) => {
  actualCourt.value = newValue || ''
})

const handleWinnerChange = (field, value) => {
  // If checkbox is checked, set the winner
  if (field === 'game1_winner_entry_id' && value === props.match.left_entry_id) {
    
    if (document.getElementById('game1_left_winner_flag').checked) {
      document.getElementById('game1_right_winner_flag').checked = false
      props.match.game1_winner_entry_id = props.match.left_entry_id
    } else {
      props.match.game1_winner_entry_id = ""
    }
    
  } 

  if (field === 'game1_winner_entry_id' && value === props.match.right_entry_id) {
    if (document.getElementById('game1_right_winner_flag').checked) {
      document.getElementById('game1_left_winner_flag').checked = false
      props.match.game1_winner_entry_id = props.match.right_entry_id
    } else {
      props.match.game1_winner_entry_id = ""
    }

  }

  if (field === 'game2_winner_entry_id' && value === props.match.left_entry_id) {
    
    if (document.getElementById('game2_left_winner_flag').checked) {
      document.getElementById('game2_right_winner_flag').checked = false
      props.match.game2_winner_entry_id = props.match.left_entry_id
    } else {
      props.match.game2_winner_entry_id = ""
    }
    
  } 

  if (field === 'game2_winner_entry_id' && value === props.match.right_entry_id) {
    if (document.getElementById('game2_right_winner_flag').checked) {
      document.getElementById('game2_left_winner_flag').checked = false
      props.match.game2_winner_entry_id = props.match.right_entry_id
    } else {
      props.match.game2_winner_entry_id = ""
    }

  }

  if (field === 'game3_winner_entry_id' && value === props.match.left_entry_id) {
    
    if (document.getElementById('game3_left_winner_flag').checked) {
      document.getElementById('game3_right_winner_flag').checked = false
      props.match.game3_winner_entry_id = props.match.left_entry_id
    } else {
      props.match.game3_winner_entry_id = ""
    }
  } 

  if (field === 'game3_winner_entry_id' && value === props.match.right_entry_id) {
    if (document.getElementById('game3_right_winner_flag').checked) {
      document.getElementById('game3_left_winner_flag').checked = false
      props.match.game3_winner_entry_id = props.match.right_entry_id
    } else {
      props.match.game3_winner_entry_id = ""
    }
  }

  if (field === 'winner_entry_id' && value === props.match.left_entry_id) {
    if (document.getElementById('match_left_winner_flag').checked) {
      document.getElementById('match_right_winner_flag').checked = false
      props.match.winner_entry_id = props.match.left_entry_id
    } else {
      props.match.winner_entry_id = ""
    }
  }

  if (field === 'winner_entry_id' && value === props.match.right_entry_id) {
    if (document.getElementById('match_right_winner_flag').checked) {
      document.getElementById('match_left_winner_flag').checked = false
      props.match.winner_entry_id = props.match.right_entry_id
    } else {
      props.match.winner_entry_id = ""
    }
  }

  // 各ゲームの勝者から勝利数を計算
  let leftWins = 0;
  let rightWins = 0;

  if (props.match.game1_winner_entry_id === props.match.left_entry_id) leftWins++;
  if (props.match.game1_winner_entry_id === props.match.right_entry_id) rightWins++;
  
  if (props.match.game2_winner_entry_id === props.match.left_entry_id) leftWins++;
  if (props.match.game2_winner_entry_id === props.match.right_entry_id) rightWins++;
  
  if (props.match.game3_winner_entry_id === props.match.left_entry_id) leftWins++;
  if (props.match.game3_winner_entry_id === props.match.right_entry_id) rightWins++;

  props.match.left_game_win_count = leftWins;
  props.match.right_game_win_count = rightWins;
}

// スコア入力フィールド以外をクリックした時の処理
const hideRangeInput = (event) => {
  // イベントがない場合（ボタンクリック時）は直接閉じる
  if (!event || (!event.target.closest('.range-popup') && !event.target.closest('.score-input-container'))) {
    activeScoreField.value = null;
  }
}

const incrementScore = (field) => {
    if (field === 'left_game1_score') {
        props.match.left_game1_score++;
    } else if (field === 'right_game1_score') {
        props.match.right_game1_score++;
    } else if (field === 'left_game2_score') {
        props.match.left_game2_score++;
    } else if (field === 'right_game2_score') {
        props.match.right_game2_score++;
    } else if (field === 'left_game3_score') {
        props.match.left_game3_score++;
    } else if (field === 'right_game3_score') {
        props.match.right_game3_score++;
    }
}

const decrementScore = (field) => {
    if (field === 'left_game1_score' && props.match.left_game1_score > 0) {
        props.match.left_game1_score--;
    } else if (field === 'right_game1_score' && props.match.right_game1_score > 0) {
        props.match.right_game1_score--;
    } else if (field === 'left_game2_score' && props.match.left_game2_score > 0) {
        props.match.left_game2_score--;
    } else if (field === 'right_game2_score' && props.match.right_game2_score > 0) {
        props.match.right_game2_score--;
    } else if (field === 'left_game3_score' && props.match.left_game3_score > 0) {
        props.match.left_game3_score--;
    } else if (field === 'right_game3_score' && props.match.right_game3_score > 0) {
        props.match.right_game3_score--;
    }
}

const isLeague = (event_id) => {
    return (getEventMethod(event_id) == "リーグ");
}

const isTournament = (event_id) => {
    return (getEventMethod(event_id) == "トーナメント");
}

const getEventMethod = (event_id) => {
    const allEvents = JSON.parse(localStorage.getItem("events"));
    const selectedEvent = ref([]);
    selectedEvent.value = allEvents;
    selectedEvent.value = Object.fromEntries(
        Object.entries(selectedEvent.value).filter(([key, value]) =>
        (event_id == value.event_id))
    );
    return selectedEvent.value[event_id].method;
}

const clearInputClicked = () => {
    let elements = document.getElementsByName("winner");
    for (let i = 0; i < elements.length; i++) {
        elements[i].checked = false;
    }
    props.match.winner_entry_id = ""
    props.match.match_status = "waiting"
    props.match.left_game1_score = ""
    props.match.left_game2_score = ""
    props.match.left_game3_score = ""
    props.match.right_game1_score = ""
    props.match.right_game2_score = ""
    props.match.right_game3_score = ""
    props.match.note = ""
    props.match.game1_winner_entry_id = ""
    props.match.game2_winner_entry_id = ""
    props.match.game3_winner_entry_id = ""
    props.match.left_game_win_count = ""
    props.match.right_game_win_count = ""
    // document.getElementById("left_score").value = ""
    // document.getElementById("right_score").value = ""
    setTimeout(function() {
        document.getElementById("clear-button").blur();
        document.getElementById("status_waiting").focus();

    });

}

const saveMatchScore = async () => {
    if (user && user.email) {
        isLoading.value = ref(true);
        const updates = {};
        
        // actualCourtをmatchに追加（常に保存）
        const updatedMatch = { ...props.match };
        updatedMatch.actual_court = actualCourt.value;
        
        updates['/2026-summer/matches/' + props.matchKey] = updatedMatch;
        await update(dbRef, updates)
        .then(async () => {
            console.log("Updated match:" + props.matchKey)
        }).catch((error) => {
            errorMessage.value = error
            console.log(error)
        }).finally(async () => {
            isLoading.value = false;
        });
        
    }
}
</script>

<style scoped>
.clickable-cell:active {
  transform: scale(0.95);
  background-color: #e9ecef !important;
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.1);
  cursor: pointer;
}
.clickable-cell label {
  cursor: pointer;
}
/* vsと選手名のセルの余白 */
.vs-cell,
.player-name-cell {
  padding: 1px !important;
  margin: 0 !important;
}

.score-input-container {
  position: relative;
  display: inline-block;
}
.range-popup-left {
  position: absolute;
  top: calc(100% + 5px);  /* 入力フィールドからの距離を増やす */
  /* left: 30%; */
  transform: translateX(-30%);
  background: #d1e7dd;
  padding: 12px 15px;  /* 上下のパディングを少し減らす */
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 1000;
  width: min(330px, 90vw); /* 画面幅の90%か230pxの小さい方 */
  margin-top: 5px;
  max-width: calc(100vw - 20px);  /* 画面の端から10pxずつ余白 */
}

.range-popup-right {
  position: absolute;
  top: calc(100% + 5px);  /* 入力フィールドからの距離を増やす */
  /* left: 30%; */
  transform: translateX(-60%);
  background: #d1e7dd;
  padding: 12px 15px;  /* 上下のパディングを少し減らす */
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  z-index: 1000;
  width: min(330px, 90vw); /* 画面幅の90%か230pxの小さい方 */
  margin-top: 5px;
  max-width: calc(100vw - 20px);  /* 画面の端から10pxずつ余白 */
}

/* .range-popup::before {
  content: '';
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 8px 8px 8px;
  border-style: solid;
  border-color: transparent transparent #d1e7dd transparent;
} */

/* 左寄せポップアップの矢印 */
.range-popup.left-align::before {
  left: 60px;  /* 矢印の位置を入力フィールドに合わせる */
  transform: none;
}

/* 右寄せポップアップの矢印 */
.range-popup.right-align::before {
  left: auto;
  right: 60px;  /* 矢印の位置を入力フィールドに合わせる */
  transform: none;
}

.range-scale {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  padding: 0 2px;
  font-size: 12px;
  color: #666;
}

.form-range {
  width: 280px;
  margin: 0;
  padding: 0;
}

/* rangeスライダーのスタイル改善 */
.form-range::-webkit-slider-thumb {
  cursor: pointer;
}

.form-range::-moz-range-thumb {
  cursor: pointer;
}

.form-range:active {
  cursor: grabbing;
}

.score-button:active {
  transform: scale(0.95);
  color: #0143a3 !important;
}
</style>
